import { defineMessages } from 'react-intl';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	meetingLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinMeetingLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	meetingLinkIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recurringEventIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recurringMetadataLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	upcomingEventsButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pastEventsButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	created: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPerson: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-calendar.calendar-label',
		defaultMessage: 'Calendar',
		description:
			'Badge label shown on a calendar search result card to identify the result type as a calendar event.',
	},
	meetingLink: {
		id: 'search-graph-calendar.meeting-link',
		defaultMessage: 'Meeting link',
		description:
			'Hyperlink label shown on a calendar search result card that opens the video or conference meeting URL associated with the event.',
	},
	joinMeetingLink: {
		id: 'search-graph-calendar.join-meeting-link',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting link',
	},
	meetingLinkIcon: {
		id: 'search-graph-calendar.meeting-link-icon',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting icon',
	},
	recurringEventIcon: {
		id: 'search-graph-calendar.recurring-event-icon',
		defaultMessage: 'Recurring event',
		description:
			'Accessible label for the icon shown on a calendar search result card to indicate the event repeats on a recurring schedule.',
	},
	recurringMetadataLabel: {
		id: 'search-graph-calendar.recurring-event-label',
		defaultMessage: 'Recurring',
		description: 'Indicates whether the calendar event has recurring events',
	},
	upcomingEventsButton: {
		id: 'search-graph-calendar.upcoming-events-button',
		defaultMessage: 'Upcoming events',
		description: 'Label for the call to action to display the upcoming events',
	},
	pastEventsButton: {
		id: 'search-graph-calendar.past-events-button',
		defaultMessage: 'Past events',
		description: 'Label for the call to action to display the past events',
	},
	created: {
		id: 'search-graph-calendar.created.placeholder',
		defaultMessage: '{person} created',
		description:
			"Metadata label on a calendar search result card showing who created the event. The placeholder {person} is substituted with the creator's display name.",
	},
	externalPerson: {
		id: 'search-graph-calendar.external-person',
		defaultMessage: 'External person',
		description: 'Calendar event external person label in case name cannot be fetched',
	},
});
